const types = {
    INTELLIGENCE_GET_GRAPH: 'INTELLIGENCE_GET_GRAPH',
    INTELLIGENCE_SAVE_GRAPH: 'INTELLIGENCE_SAVE_GRAPH',
    INTELLIGENCE_LOAD_MY_GRAPHS: 'INTELLIGENCE_LOAD_MY_GRAPHS',
    INTELLIGENCE_LOAD_SHARED_GRAPHS: 'INTELLIGENCE_LOAD_SHARED_GRAPHS',
    INTELLIGENCE_DELETE_GRAPH: 'INTELLIGENCE_DELETE_GRAPH',
    INTELLIGENCE_SEARCH_ENTITIES: 'INTELLIGENCE_SEARCH_ENTITIES',
    INTELLIGENCE_SEARCH_EXPAND_ENTITIES: 'INTELLIGENCE_SEARCH_EXPAND_ENTITIES',
    INTELLIGENCE_EXPAND_DINARDAP_ENTITIES: 'INTELLIGENCE_EXPAND_DINARDAP_ENTITIES',
    INTELLIGENCE_STORE_ENTITIES: 'INTELLIGENCE_STORE_ENTITIES'
}

export default types;

export const saveGraph = (graph, onSuccess, onError) => {
    return { type: types.INTELLIGENCE_SAVE_GRAPH, payload: { graph, onSuccess, onError } };
}

export const loadMyGraphs = (onSuccess, onError) => {
    return { type: types.INTELLIGENCE_LOAD_MY_GRAPHS, payload: { onSuccess, onError } }
}

export const loadSharedGraphs = (onSuccess, onError) => {
    return { type: types.INTELLIGENCE_LOAD_SHARED_GRAPHS, payload: { onSuccess, onError } }
}

export const deleteGraphById = (id, onSuccess, onError) => {
    return { type: types.INTELLIGENCE_DELETE_GRAPH, payload: { id, onSuccess, onError } };
}

export const getSearchEntities = (text) => {
    return { type: types.INTELLIGENCE_SEARCH_ENTITIES, payload: { text } };
}

export const getSearchExpandEntities = (text, fromId, source, semanticType) => {
    return { type: types.INTELLIGENCE_SEARCH_EXPAND_ENTITIES, payload: { text, fromId, source, semanticType } };
}

export const getExpandByIndentificationDinardapEntities = (text, fromId, source, packets) => {
    return { type: types.INTELLIGENCE_EXPAND_DINARDAP_ENTITIES, payload: { text, fromId, source, packets } };
}

export const storeSearchEntities = (response) => {
    return { type: types.INTELLIGENCE_STORE_ENTITIES, payload: response };
}
